import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';

import { categorySingleOptionFormatter } from 'components/forms/autocomplete/Category';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormLangInput from "components/forms/FormLangInput";
import FormInput from "components/forms/FormInput";
import FormLangAutocomplete from "components/forms/FormLangAutocomplete";
import {forEach as _forEach} from "lodash";

class FormItemSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      category: null,
    };
  }

  categorySelected = (name, category) => {
    this.setState({ category });
  };

  render() {
    const {
      intl: { messages },
      name,
      disabled,
      onSelect,
      value
    } = this.props;
    const { category } = this.state;

    const urlFilters = {};
    if (category) {
      urlFilters.category = category.path;
    }

    return (
      <React.Fragment>
        <Row className="clearfix">
          <Col sm={12}>
            <FormAutocomplete
              name="category"
              autocompleteType="category"
              label={messages.category}
              value={categorySingleOptionFormatter(category)}
              disabled={disabled}
              returnValueObject
              onChange={this.categorySelected}
            />
          </Col>
          {/*<Col sm={1} className="form-group form-group-default p-t-10 p-b-5">
            <label>&nbsp;</label>
            <div className="">
              <Button className="btn-link" block onClick={this.expandOptions}>
                <i className="fa fa-chevron-down" />
              </Button>
            </div>
          </Col>*/}
        </Row>
        <Row className="clearfix">
          <Col sm={12}>
            <FormLangAutocomplete
              onChange={onSelect}
              name={name}
              label={messages.add_product}
              disabled={disabled}
              autocompleteType="item"
              returnValueObject
              urlFilters={urlFilters}
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
FormItemSearch.defaultProps = {
  name: 'items',
  onSelect: () => {},
};

export default injectIntl(FormItemSearch);
